import React, { lazy, Suspense } from 'react';

const SetPasswordComponent = lazy(() => import('./set-password.component'));

const SetPasswordLazyComponent = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <SetPasswordComponent {...props} />
  </Suspense>
);

export default SetPasswordLazyComponent;
